import React, { useState, useCallback } from 'react';
import { applicationActions } from '@apply/adminStore';
import ActionSheet from 'devextreme-react/action-sheet';
import store from '@apply/adminStore';
import { Button, ButtonTheme } from '@apply/components';
import { ButtonBorderRadius } from '@apply/components/src/components/controls/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';

export const IncompleteAppsActionButton = ({ data, parentElementId }) => {
    const { dispatch } = store;

    const [actionData, setActionData] = useState({
        visible: false,
        target: null,
        items: [],
    });

    const buildActions = useCallback((applicationId) => {
        return [
            {
                id: 0,
                text: 'Review',
                applicationId,
                stylingMode: 'contained',
            },
            {
                id: 1,
                text: 'Lost/Delete',
                applicationId,
                type: 'danger',
                icon: 'remove',
            },
        ];
    }, []);

    const onActionClicked = useCallback(
        (event, applicationId) => {
            event.preventDefault();
            event.stopPropagation();

            setActionData({
                visible: true,
                target: `#${event.currentTarget.id}`,
                items: buildActions(applicationId),
            });
        },
        [buildActions]
    );

    const onActionItemClick = useCallback(
        (e) => {
            // Temporary override — keeps existing logic intact
            alert('Actions Menu in Development');

            return; // ← prevents the real logic from running

            // --- existing behavior (preserved, but unreachable) ---
            const { id, applicationId } = e.itemData;

            setActionData((prev) => ({ ...prev, visible: false }));

            if (id === 0) {
                dispatch(
                    applicationActions.setIncompleteReviewModal({
                        incompleteReviewModal: {
                            isOpen: true,
                            id: applicationId,
                        },
                    })
                );
            }

            if (id === 1) {
                dispatch(
                    applicationActions.setDeclineOrRecycleModal({
                        declineOrRecycleModal: {
                            isOpen: true,
                            id: applicationId,
                        },
                    })
                );
            }
        },
        [dispatch]
    );

    const onVisibleChange = useCallback((visible) => {
        setActionData((prev) => (prev.visible === visible ? prev : { ...prev, visible }));
    }, []);

    if (!data) return null;

    const buttonId = `action_bridge_incomplete_${parentElementId ?? ''}_${data.id}`;

    return (
        <>
            <Button
                id={buttonId}
                hint='Click to see options'
                handleClick={(event) => onActionClicked(event, data.id)}
                height='20px'
                width='24px'
                theme={ButtonTheme.GridGrey}
                borderRadius={ButtonBorderRadius.Small}
            >
                <FontAwesomeIcon icon={faEllipsis} />
            </Button>

            <ActionSheet
                title='Choose action'
                usePopover
                visible={actionData.visible}
                target={actionData.target}
                items={actionData.items}
                onItemClick={onActionItemClick}
                onVisibleChange={onVisibleChange}
                showTitle={false}
            />
        </>
    );
};
